export default __webpack_public_path__ + "static/media/ArmButtonInActive.b90e8601.svg";